/**
 * This is an attempt to isolate code duplicated between PhoneNumber and TextField.
 * This should ease maintenance currently and possibly be used to share code in the future.
 */

type TextFieldInputPropsParams = {
  validateAtGroupLevel?: boolean
  value?: string
  maxLength?: number
  helpMessage?: string
  validMessage?: string
  errorMessage?: string
  warningValidate?(value: string): string
  ariaDescribedBy?: string
  inputId: string
}

type TextFieldInputProps = {
  'aria-describedby'?: string
  'aria-invalid'?: string
  'aria-errormessage'?: string
}

export default function useTextFieldInputProps({
  validateAtGroupLevel,
  value,
  maxLength,
  helpMessage,
  validMessage,
  errorMessage,
  warningValidate,
  ariaDescribedBy,
  inputId,
}: TextFieldInputPropsParams): TextFieldInputProps {
  // #region Copied from TextField.js
  // this matches the logic for rending help text in InputBase
  const showHelpText =
    (helpMessage || (warningValidate && warningValidate(value)) || validMessage || maxLength) &&
    !validateAtGroupLevel &&
    !errorMessage

  // Need to conditionally render aria-describedby depending on whether or not inputBase is rendering help text (but not error messages, those are handled by aria-errormessage instead)
  const ariaDescription = showHelpText ? ariaDescribedBy || `${inputId}_description` : undefined
  const ariaErrorMessage = errorMessage && !ariaDescribedBy ? `${inputId}_description` : undefined
  // #endregion

  return {
    'aria-describedby': ariaDescription,
    'aria-invalid': errorMessage ? 'true' : undefined,
    'aria-errormessage': ariaErrorMessage,
  }
}
